import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "NFC Import", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("To write the bring Import Link to an NFC Tag, simply click the button, place the Tag close to the device and wait until a redirect to the Import occurs. ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("warning, the Tag will be overridden if it's not readonly!")
const _hoisted_5 = { key: 1 }

import { computed } from 'vue'

/* global NDEFReader */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isNFCCapable = computed(() => 'NDEFReader' in window)

const doWrite = async () => {
  const ndef = new NDEFReader()

  try {
    await ndef.write({
      records: [{
        recordType: 'url',
        data: window.location.href
      }]
    }, { overwrite: true })
  } catch (error) {
    alert(`Error! Scan failed to start: ${error}.`)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_string = _resolveComponent("string")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_unref(isNFCCapable))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _hoisted_3,
            _createVNode(_component_string, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (doWrite()))
          }, "Write to NFC Chip")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, "Your device does not know anything about NFC"))
  ], 64))
}
}

})